module.exports = __webpack_public_path__ + "img/afsaka_no.19753e19.png";